"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminStatus = exports.AdminRole = void 0;
exports.AdminRole = {
    관리자: '관리자',
    최고관리자: '최고관리자',
};
exports.AdminStatus = {
    정상: '정상',
    차단: '차단',
    삭제: '삭제',
};
